import axios from "../api/apiConfig";
import { settings } from "../apiSettings.js";

const getShopifyProducts = () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/shopify/products")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const streamShopifyProducts = (
  onBatch: (batch: any[], totalSoFar: number) => void,
  onDone: (total: number) => void,
  onError: (message: string) => void
): EventSource => {
  const url = `${settings.baseURL}/api/v1/shopify/products-stream`;
  const es = new EventSource(url);

  es.onmessage = (event: MessageEvent) => {
    try {
      const data = JSON.parse(event.data);
      if (data.done) {
        es.close();
        if (data.error) {
          onError(data.error);
        } else {
          onDone(data.totalSoFar ?? 0);
        }
      } else {
        onBatch(data.batch, data.totalSoFar);
      }
    } catch {
      es.close();
      onError("Failed to parse server response");
    }
  };

  es.onerror = () => {
    es.close();
    onError("Connection error while downloading products");
  };

  return es;
};

const streamShopifySales = (
  startDate: string,
  endDate: string,
  onBatch: (batch: any[], totalSoFar: number) => void,
  onDone: (total: number) => void,
  onError: (message: string) => void
): EventSource => {
  const url = `${settings.baseURL}/api/v1/shopify/sales-stream?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
  const es = new EventSource(url);

  es.onmessage = (event: MessageEvent) => {
    try {
      const data = JSON.parse(event.data);
      if (data.done) {
        es.close();
        if (data.error) {
          onError(data.error);
        } else {
          onDone(data.totalSoFar ?? 0);
        }
      } else {
        onBatch(data.batch, data.totalSoFar);
      }
    } catch {
      es.close();
      onError("Failed to parse server response");
    }
  };

  es.onerror = () => {
    es.close();
    onError("Connection error while downloading sales");
  };

  return es;
};

export { getShopifyProducts, streamShopifyProducts, streamShopifySales };